import React from "react";
import { Link } from "react-router-dom";
import HeaderLeft from "./HeaderLeft";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";

function OtpVerificationNumber(props) {
  const initialValues = {
    one: "",
    two: "",
    three: "",
    four: "",
    five: "",
    six: "",
  };
  const validationSchema = Yup.object({
    email: Yup.string().email("Invalid email format").required("required"),
    password: Yup.string()
      .required("required")
      .min(6, "Password is too short - should be 8 chars minimum.")
      .matches(/(?=.*[0-9])/, "Password must contain a number."),
  });
  const onSubmit = async (values) => {
    console.log("five digit otp value", values);
  };
  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit}>
      {({ values, handleChange, handleBlur, handleSubmit }) => (
        <>
          <header>
            <div className="custom_container ">
              <HeaderLeft />
              <div className="user_profile"></div>
            </div>
          </header>
          <section className="otp_verification custom_hight">
            <div className="login_inner">
              <h1 className="mb_30 main_title ">OTP Verification</h1>
              <p className="mb_40 them_para text-center mx-auto">
                We have sent a 5 digit OTP to user@gmail.com.
                <br />
                Please enter the OTP to continue
              </p>
              <form
                onSubmit={handleSubmit}
                action="index_submit"
                method="get"
                acceptCharset="utf-8"
              >
                <div className="otp_wraper">
                  <input
                    type="one"
                    name="one"
                    onChange={handleChange("one")}
                    onBlur={handleBlur("one")}
                    value={values.one}
                    className="otp_input"
                    maxlength="1"
                    placeholder="2"
                  />
                  <input
                    onChange={handleChange("two")}
                    onBlur={handleBlur("two")}
                    value={values.two}
                    type="text"
                    name="two"
                    className="otp_input "
                    maxlength="1"
                    placeholder="3"
                  />
                  <input
                    type="text"
                    name="three"
                    onChange={handleChange("three")}
                    onBlur={handleBlur("three")}
                    value={values.three}
                    className="otp_input "
                    maxlength="1"
                    placeholder="4"
                  />
                  <input
                    type="text"
                    name="four"
                    onChange={handleChange("four")}
                    onBlur={handleBlur("four")}
                    value={values.four}
                    className="otp_input "
                    maxlength="1"
                    placeholder="2"
                  />
                  <input
                    type="text"
                    name="five"
                    onChange={handleChange("five")}
                    onBlur={handleBlur("five")}
                    value={values.five}
                    className="otp_input "
                    maxlength="1"
                    placeholder="6"
                  />
                </div>
                <div className="btn_wraper">
                  {/*  <button type="submit" className="them_btn mt_40 mb_30">
                    Continue
                  </button> */}
                  <Link to="/welcomePersonalInfo">
                    <button type="button" className="them_btn mt_40 mb_30">
                      Continue
                    </button>
                  </Link>
                </div>
              </form>
              <p className="them_para mx-auto  mt_40">
                Didn't Receive Code?
                <a href="" className="btn-link  ">
                  Resend Code
                </a>
              </p>
            </div>
          </section>
        </>
      )}
    </Formik>
  );
}

export default OtpVerificationNumber;
